<style>
  /* ::ng-deep .mat-form-field-appearance-outline .mat-form-field-outline .mat-form-field-outline-start,
  ::ng-deep .mat-form-field-appearance-outline .mat-form-field-outline .mat-form-field-outline-end {
  border-width: 2px;
  border-color:black;
  } */
</style>

<!-- Step 1 : Construct shipment form https://reactgo.com/angular-turnoff-autocomplete/#:~:text=To%20disable%20the%20autocomplete%20for,its%20autocomplete%20attribute%20to%20off%20.&text=We%20can%20also%20disable%20the,the%20html%20element.-->
<div class="construct-shipment v35-shipment" [class.v35-french]="isFrench">
  <div class="construct-shipment__row v35-flip-row" style="margin-top: 10px">
    <button
      mat-mini-fab
      color="warn"
      type="button"
      class="swapButton"
      (click)="swapAddresses()"
      matTooltip="{{ 'app.misc.swapAddresses' | translate }}"
      matTooltipPosition="right"
    >
      <mat-icon>swap_horiz</mat-icon>
    </button>
  </div>
  <!-- Contains shipper and consignee informations -->
  <div class="construct-shipment__row v35-addresses">
    <!-- Shipper card -->
    <div class="construct-shipment__card" [formGroup]="parentForm">
      <mat-card appearance="outlined">
        <!-- Card title -->
        <mat-card-title><mat-icon class="v35-heading-icon">outbox</mat-icon>
          {{ "app.shopifyOrders.details.shipper" | translate }}
        </mat-card-title>

        <!-- Content that display a shipper form -->
        <mat-card-content>
          <div class="form" formGroupName="shipperForm">
            <!-- Compagny name input line -->
            <!-- https://www.tutsmake.com/angular-11-autocomplete-using-angular-material-example/ -->
            @if (!isQuickQuote) {
              <mat-form-field appearance="outline">
                <mat-label>{{ "app.shopifyOrders.details.shipperConsigneeDetails.companyName" | translate }}</mat-label>
                <input
                  matInput
                  required
                  maxlength="100"
                  [matAutocomplete]="autoShipperCompanyName"
                  placeholder="{{ 'app.shopifyOrders.details.shipperConsigneeDetails.companyName' | translate }}"
                  formControlName="companyName"
                  id="companyNameText"
                  (ngModelChange)="onShipperValueChanged()"
                  autocomplete="shipper"
                />
                <mat-autocomplete
                  #autoShipperCompanyName="matAutocomplete"
                  [displayWith]="GetDisplay(true)"
                  (optionSelected)="SelectedAddress(true, $event)"
                >
                  @for (option of originAddresses | async; track option) {
                    <mat-option style="line-height: normal" [value]="option.Row">
                      <div style="font-size: 14px; font-weight: bold">{{ option.AddressTitle }}</div>
                      <div style="font-size: 12px; color: gray">{{ option.AddressDetail }}</div>
                    </mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
            }

            <!-- Person name input line -->
            @if (!isQuickQuote) {
              <mat-form-field appearance="outline">
                <mat-label>{{ "app.shopifyOrders.details.shipperConsigneeDetails.personName" | translate }}</mat-label>
                <input
                  matInput
                  required
                  autocomplete="shipper"
                  minlength="3"
                  maxlength="100"
                  placeholder="{{ 'app.shopifyOrders.details.shipperConsigneeDetails.personName' | translate }}"
                  formControlName="personName"
                  (ngModelChange)="onShipperValueChanged()"
                />
              </mat-form-field>
            }

            <!-- Country input line with selector-->
            <mat-form-field appearance="outline">
              <mat-label>
                {{ "app.shopifyOrders.details.shipperConsigneeDetails.countryName" | translate }}
              </mat-label>
              <mat-select
                required
                formControlName="countryID"
                (selectionChange)="changeCountryEvent(true)"
                (ngModelChange)="onShipperValueChanged()"
                [typeaheadDebounceInterval]="500"
              >
                @for (country of countriesList; track country) {
                  <mat-option [value]="country.CON_ID">
                    {{ country.CON_Name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>

            <!-- Phone number and email input line -->
            @if (!isQuickQuote) {
              <div class="form__row">
                <!-- Phone number -->
                <mat-form-field appearance="outline">
                  <mat-label>{{ "app.shopifyOrders.details.shipperConsigneeDetails.phone" | translate }}</mat-label>
                  <!-- <input required matInput type="text" prefix="+1 " mask="(000) 000-0000" autocomplete="shipper" -->
                  <input
                    required
                    matInput
                    type="text"
                    mask="{{ phoneMaskOrigin }}"
                    autocomplete="shipper"
                    placeholder="{{ 'app.shopifyOrders.details.shipperConsigneeDetails.phone' | translate }}"
                    formControlName="phone"
                  />
                </mat-form-field>
                <!-- Phone extension -->
                <mat-form-field appearance="outline">
                  <mat-label
                    >{{ "app.shopifyOrders.details.shipperConsigneeDetails.phone" | translate }} Ext.</mat-label
                  >
                  <input
                    matInput
                    type="text"
                    autocomplete="shipper"
                    maxlength="50"
                    placeholder="{{ 'app.shopifyOrders.details.shipperConsigneeDetails.phone' | translate }} Ext."
                    formControlName="extension"
                  />
                </mat-form-field>
              </div>
            }

            @if (!isQuickQuote) {
              <div class="form__row">
                <!-- Email -->
                <mat-form-field appearance="outline">
                  <mat-label>{{ "app.shopifyOrders.details.shipperConsigneeDetails.email" | translate }}</mat-label>
                  <input
                    matInput
                    required
                    autocomplete="shipper"
                    maxlength="200"
                    placeholder="{{ 'app.shopifyOrders.details.shipperConsigneeDetails.email' | translate }}"
                    formControlName="email"
                  />
                </mat-form-field>
                <!-- Checkbox to indicate if it is a residential address    -->
                
              </div>
            }

            <!-- Google search box -->
            @if (!isQuickQuote) {
              <mat-form-field class="full-width v35-search-field" [appearance]="appearance">
                
                <!------------------------------------------------------------------------------------------------------------------------
                          -- Pour désactiver le autofill du browser quand un input est géré par
                          -- Google Places AutoComplete faut ajouter onfocus comme vous le voyez ici-bas
                          -- https://stackoverflow.com/questions/29931712/chrome-autofill-covers-autocomplete-for-google-maps-api-v3/56632769#56632769
                          ------------------------------------------------------------------------------------------------------------------------->
                <input
                  ngx-google-places-autocomplete
                  matInput
                  placeholder="{{ 'app.misc.searchAddress' | translate }}"
                  class="form-control v35-address-search"
                  autocomplete="shipper"
                  (focus)="changeCountryEvent(true)"
                  onfocus="this.setAttribute('autocomplete', 'shipper')"
                  #shipperSearchAddress
                />
              </mat-form-field>
            }

            <!-- Street No, Street Name and Unit -->
            @if (!isQuickQuote) {
              <div class="form__row">
                <!-- Street name input line -->
                <mat-form-field appearance="outline">
                  <mat-label>{{
                    "app.shopifyOrders.details.shipperConsigneeDetails.streetName" | translate
                  }}</mat-label>
                  <input
                    matInput
                    required
                    autocomplete="shipper"
                    maxlength="100"
                    placeholder="{{ 'app.shopifyOrders.details.shipperConsigneeDetails.streetName' | translate }}"
                    formControlName="streetName"
                    (ngModelChange)="onShipperValueChanged()"
                  />
                </mat-form-field>
                <!-- Unit -->
                <mat-form-field appearance="outline">
                  <mat-label>{{ "app.shopifyOrders.details.shipperConsigneeDetails.unit" | translate }}</mat-label>
                  <input
                    matInput
                    maxlength="100"
                    placeholder="{{ 'app.shopifyOrders.details.shipperConsigneeDetails.unit' | translate }}"
                    autocomplete="shipper"
                    formControlName="unit"
                    #shipperUnitElement
                    (ngModelChange)="onShipperValueChanged()"
                  />
                </mat-form-field>
              </div>
            }

            <!-- City input line -->
            <mat-form-field appearance="outline">
              <mat-label>{{ "app.shopifyOrders.details.shipperConsigneeDetails.cityName" | translate }}</mat-label>
              <input
                matInput
                [required]="!isQuickQuote"
                autocomplete="shipper"
                maxlength="100"
                placeholder="{{ 'app.shopifyOrders.details.shipperConsigneeDetails.cityName' | translate }}"
                formControlName="cityName"
                (ngModelChange)="onShipperValueChanged()"
              />
            </mat-form-field>

            <!-- Postal code and province input line -->
            <div class="form__row">
              <!-- Postal Code -->
              <div style="width: 50%">
                <mat-form-field appearance="outline">
                  <mat-label>{{ "app.shopifyOrders.details.shipperConsigneeDetails.zipCode" | translate }}</mat-label>
                  <input
                    matInput
                    required
                    autocomplete="shipper"
                    maxlength="50"
                    placeholder="{{ 'app.shopifyOrders.details.shipperConsigneeDetails.zipCode' | translate }}"
                    formControlName="zipCode"
                    (ngModelChange)="onShipperValueChanged()"
                  />
                </mat-form-field>
              </div>

              <!-- List of states / provinces -->
              @if (!isQuickQuote) {
                <div style="width: 49%">
                  <mat-form-field appearance="outline">
                    <mat-label>
                      {{ "app.misc.state" | translate }}
                    </mat-label>
                    <mat-select
                      matNativeControl
                      formControlName="stateID"
                      required
                      (ngModelChange)="onShipperValueChanged()"
                    >
                      @for (state of shipperFilteredStateProvinces; track state) {
                        <mat-option [value]="state.PRV_ID">
                          {{ state.PRV_Name }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }
            </div>

            @if (isQuickQuote) {
              <div class="form__row">
                <!-- Checkbox to indicate if it is a residential address    -->
                <mat-checkbox class="v35-switch" formControlName="isResidential">
                    {{ "app.shopifyOrders.details.isResidential" | translate }}</mat-checkbox
                  >
              </div>
            }

            <!-- Special instructions -->
            @if (!isQuickQuote) {
              <mat-form-field appearance="outline">
                <mat-label>{{ "app.shopifyOrders.details.specialInstruction" | translate }} (1000c)</mat-label>
                <textarea
                  matInput
                  maxlength="1000"
                  autocomplete="shipper"
                  placeholder="{{ 'app.shopifyOrders.details.specialInstruction' | translate }}"
                  formControlName="specialInstruction"
                >
                </textarea>
              </mat-form-field>
            }
          </div>

          <div class="v35-address-actions" [formGroup]="shipper()">
            @if (!isQuickQuote) {
              <div class="v35-residential-bottom"><mat-checkbox class="v35-switch" formControlName="isResidential">
                    {{ "app.shopifyOrders.details.isResidential" | translate }}</mat-checkbox
                  ></div>
            }
            <!-- Button to save the address -->
            @if (!isQuickQuote) {
              <button
                [disabled]="disableShipperSaveAddress || !shipper().valid"
                type="button"
                mat-raised-button
                color="primary"
                (click)="saveCurrentAddress(true)"
              >
                {{ "app.addressEditor.saveAddress" | translate }}
                <mat-icon class="material-icons"> save </mat-icon>
              </button>
            }

            <!-- Checkbox for different billing address -->
            @if (isCreditCard) {
              <div style="display: flex; align-items: center; gap: 16px">
                <mat-checkbox class="v35-switch"
                  #billingCheckbox
                  [checked]="hasBillingAddress()"
                  (change)="toggleBillingAddress($event.checked, billingCheckbox)"
                >
                  {{ "app.misc.billingAddress" | translate }}
                </mat-checkbox>
                @if (hasBillingAddress()) {
                  <button
                    mat-icon-button
                    type="button"
                    class="edit-btn"
                    aria-label="Edit billing address"
                    (click)="onEditBillingAddress()"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>
                }
              </div>
            }
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Consignee card -->
    <div class="construct-shipment__card" [formGroup]="parentForm">
      <mat-card appearance="outlined">
        <!-- Card title -->
        <mat-card-title><mat-icon class="v35-heading-icon">move_to_inbox</mat-icon>
          {{ "app.shopifyOrders.details.consignee" | translate }}
        </mat-card-title>

        <!-- Content that display a consignee form  -->
        <mat-card-content>
          <div class="form" formGroupName="consigneeForm">
            <!-- Compagny name input line -->
            @if (!isQuickQuote) {
              <mat-form-field appearance="outline">
                <mat-label>{{ "app.shopifyOrders.details.shipperConsigneeDetails.companyName" | translate }}</mat-label>
                <input
                  matInput
                  required
                  maxlength="100"
                  [matAutocomplete]="autoConsigneeCompanyName"
                  placeholder="{{ 'app.shopifyOrders.details.shipperConsigneeDetails.companyName' | translate }}"
                  formControlName="companyName"
                  (ngModelChange)="onConsigneeValueChanged()"
                />
                <mat-autocomplete
                  #autoConsigneeCompanyName="matAutocomplete"
                  [displayWith]="GetDisplay(false)"
                  (optionSelected)="SelectedAddress(false, $event)"
                >
                  @for (option of destinationAddresses | async; track option) {
                    <mat-option style="line-height: normal" [value]="option.Row">
                      <div style="font-size: 14px; font-weight: bold">{{ option.AddressTitle }}</div>
                      <div style="font-size: 12px; color: gray">{{ option.AddressDetail }}</div>
                    </mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
            }

            <!-- Person name input line -->
            @if (!isQuickQuote) {
              <mat-form-field appearance="outline">
                <mat-label>{{ "app.shopifyOrders.details.shipperConsigneeDetails.personName" | translate }}</mat-label>
                <input
                  matInput
                  required
                  autocomplete="consignee"
                  minlength="3"
                  maxlength="100"
                  placeholder="{{ 'app.shopifyOrders.details.shipperConsigneeDetails.personName' | translate }}"
                  formControlName="personName"
                  (ngModelChange)="onConsigneeValueChanged()"
                />
              </mat-form-field>
            }

            <!-- Country input line with selector-->
            <mat-form-field appearance="outline">
              <mat-label>
                {{ "app.shopifyOrders.details.shipperConsigneeDetails.countryName" | translate }}
              </mat-label>
              <mat-select
                required
                formControlName="countryID"
                (selectionChange)="changeCountryEvent(false)"
                (ngModelChange)="onConsigneeValueChanged()"
                [typeaheadDebounceInterval]="500"
              >
                @for (country of countriesList; track country) {
                  <mat-option [value]="country.CON_ID">
                    {{ country.CON_Name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>

            <!-- Phone number and email input line REF: https://www.npmjs.com/package/ngx-mask -->
            @if (!isQuickQuote) {
              <div class="form__row">
                <!-- Phone number -->
                <mat-form-field appearance="outline">
                  <mat-label>{{ "app.shopifyOrders.details.shipperConsigneeDetails.phone" | translate }}</mat-label>
                  <!-- <input required matInput type="text" prefix="+1 " mask="(000) 000-0000" autocomplete="consignee" -->
                  <input
                    required
                    matInput
                    type="text"
                    mask="{{ phoneMaskDesctination }}"
                    autocomplete="consignee"
                    placeholder="{{ 'app.shopifyOrders.details.shipperConsigneeDetails.phone' | translate }}"
                    formControlName="phone"
                  />
                </mat-form-field>
                <!-- Phone extension -->
                <mat-form-field appearance="outline">
                  <mat-label
                    >{{ "app.shopifyOrders.details.shipperConsigneeDetails.phone" | translate }} Ext.</mat-label
                  >
                  <input
                    matInput
                    type="text"
                    autocomplete="consignee"
                    maxlength="50"
                    placeholder="{{ 'app.shopifyOrders.details.shipperConsigneeDetails.phone' | translate }} Ext."
                    formControlName="extension"
                  />
                </mat-form-field>
              </div>
            }

            @if (!isQuickQuote) {
              <div class="form__row">
                <!-- Email -->
                <mat-form-field appearance="outline">
                  <mat-label>{{ "app.shopifyOrders.details.shipperConsigneeDetails.email" | translate }}</mat-label>
                  <input
                    matInput
                    required
                    autocomplete="consignee"
                    maxlength="200"
                    placeholder="{{ 'app.shopifyOrders.details.shipperConsigneeDetails.email' | translate }}"
                    formControlName="email"
                  />
                </mat-form-field>
                <!-- Checkbox to indicate if it is a residential address    -->
                
              </div>
            }

            <!-- Google search box -->
            @if (!isQuickQuote) {
              <mat-form-field class="full-width v35-search-field" [appearance]="appearance">
                
                <!------------------------------------------------------------------------------------------------------------------------
                                              -- Pour désactiver le autofill du browser quand un input est géré par
                                              -- Google Places AutoComplete faut ajouter onfocus comme vous le voyez ici-bas
                                              -- https://stackoverflow.com/questions/29931712/chrome-autofill-covers-autocomplete-for-google-maps-api-v3/56632769#56632769
                                              ------------------------------------------------------------------------------------------------------------------------->
                <input
                  ngx-google-places-autocomplete
                  matInput
                  placeholder="{{ 'app.misc.searchAddress' | translate }}"
                  class="form-control v35-address-search"
                  autocomplete="consignee"
                  (focus)="changeCountryEvent(false)"
                  onfocus="this.setAttribute('autocomplete', 'consignee');"
                  #consigneeSearchAddress
                />
              </mat-form-field>
            }

            <!-- Street No, Street Name and Unit -->
            @if (!isQuickQuote) {
              <div class="form__row">
                <!-- Street name input line -->
                <mat-form-field appearance="outline">
                  <mat-label>{{
                    "app.shopifyOrders.details.shipperConsigneeDetails.streetName" | translate
                  }}</mat-label>
                  <input
                    matInput
                    required
                    autocomplete="consignee"
                    maxlength="100"
                    placeholder="{{ 'app.shopifyOrders.details.shipperConsigneeDetails.streetName' | translate }}"
                    formControlName="streetName"
                    (ngModelChange)="onConsigneeValueChanged()"
                  />
                </mat-form-field>
                <!-- Unit -->
                <mat-form-field appearance="outline">
                  <mat-label>{{ "app.shopifyOrders.details.shipperConsigneeDetails.unit" | translate }}</mat-label>
                  <input
                    matInput
                    maxlength="100"
                    placeholder="{{ 'app.shopifyOrders.details.shipperConsigneeDetails.unit' | translate }}"
                    autocomplete="consignee"
                    formControlName="unit"
                    #consigneeUnitElement
                    (ngModelChange)="onConsigneeValueChanged()"
                  />
                </mat-form-field>
              </div>
            }

            <!-- City input line -->
            <mat-form-field appearance="outline">
              <mat-label>{{ "app.shopifyOrders.details.shipperConsigneeDetails.cityName" | translate }}</mat-label>
              <input
                matInput
                [required]="!isQuickQuote"
                autocomplete="consignee"
                maxlength="100"
                placeholder="{{ 'app.shopifyOrders.details.shipperConsigneeDetails.cityName' | translate }}"
                formControlName="cityName"
                (ngModelChange)="onConsigneeValueChanged()"
              />
            </mat-form-field>

            <!-- Postal code and province input line -->
            <div class="form__row">
              <!-- Postal Code -->
              <div style="width: 50%">
                <mat-form-field appearance="outline">
                  <mat-label>{{ "app.shopifyOrders.details.shipperConsigneeDetails.zipCode" | translate }}</mat-label>
                  <input
                    matInput
                    required
                    autocomplete="consignee"
                    maxlength="50"
                    placeholder="{{ 'app.shopifyOrders.details.shipperConsigneeDetails.zipCode' | translate }}"
                    formControlName="zipCode"
                    (ngModelChange)="onConsigneeValueChanged()"
                  />
                </mat-form-field>
              </div>

              <!-- List of states / provinces -->
              @if (!isQuickQuote) {
                <div style="width: 49%">
                  <mat-form-field appearance="outline">
                    <mat-label>
                      {{ "app.misc.state" | translate }}
                    </mat-label>
                    <mat-select
                      matNativeControl
                      formControlName="stateID"
                      required
                      (ngModelChange)="onConsigneeValueChanged()"
                    >
                      @for (state of consigneeFilteredStateProvinces; track state) {
                        <mat-option [value]="state.PRV_ID">
                          {{ state.PRV_Name }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }
            </div>

            @if (isQuickQuote) {
              <div class="form__row">
                <!-- Checkbox to indicate if it is a residential address    -->
                <mat-checkbox class="v35-switch" formControlName="isResidential">
                    {{ "app.shopifyOrders.details.isResidential" | translate }}</mat-checkbox
                  >
              </div>
            }

            <!-- Special instructions -->
            @if (!isQuickQuote) {
              <mat-form-field appearance="outline">
                <mat-label>{{ "app.shopifyOrders.details.specialInstruction" | translate }} (1000c)</mat-label>
                <textarea
                  matInput
                  maxlength="1000"
                  placeholder="{{ 'app.shopifyOrders.details.specialInstruction' | translate }}"
                  formControlName="specialInstruction"
                >
                </textarea>
              </mat-form-field>
            }
          </div>

          <div class="v35-address-actions" [formGroup]="consignee()">
            @if (!isQuickQuote) {
              <div class="v35-residential-bottom"><mat-checkbox class="v35-switch" formControlName="isResidential">
                    {{ "app.shopifyOrders.details.isResidential" | translate }}</mat-checkbox
                  ></div>
            }
          <!-- Button to save the address -->
          @if (!isQuickQuote) {
            <button
              [disabled]="disableConsigneeSaveAddress || !consignee().valid"
              type="button"
              mat-raised-button
              color="primary"
              (click)="saveCurrentAddress(false)"
            >
              {{ "app.addressEditor.saveAddress" | translate }}
              <mat-icon class="material-icons"> save </mat-icon>
            </button>
          }
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <!-- Shipment Details Task#4918 -->
  @if (productFormVisible && !isQuickQuote) {
    <div class="construct-shipment__row" [formGroup]="parentForm">
      <div class="construct-shipment__card">
        <mat-card appearance="outlined">
          <mat-card-title><mat-icon class="v35-heading-icon">description</mat-icon>{{ "app.misc.document" | translate }}</mat-card-title>
          <mat-card-content>
            <div formGroupName="optionForm">
              <div class="form__row v35-document-toggle">
                <!-- Ajout d'un composant div pour limiter l'espace occupé par le checkbox -->
                <div>
                  <mat-checkbox class="v35-switch" formControlName="IsDocumentOnly" (change)="changeDocumentOnlyStatus($event.checked)">
                      {{ "app.shopifyOrders.details.packageDetails.isDocumentOnly" | translate }}
                    </mat-checkbox>
                </div>
              </div>
              <div class="form__row">
                <!-- Content Description -->
                <mat-form-field appearance="outline" class="shipment-summary-field">
                  <mat-label>{{ "app.misc.contentDescriptionLabel" | translate }} (90c)</mat-label>
                  <textarea
                    matInput
                    maxlength="90"
                    rows="1"
                    placeholder="{{ 'app.misc.contentDescriptionPlaceHolder' | translate }}"
                    formControlName="ContentDescription"
                  >
                  </textarea>
                </mat-form-field>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  }

  <!-- Package Detail Form -->
  <div class="construct-shipment__row" [formGroup]="parentForm">
    <div class="construct-shipment__card">
      <mat-card appearance="outlined">
        <!-- Card title -->
        <mat-card-title class="v35-package-heading">
          <span class="v35-heading-title"><mat-icon class="v35-heading-icon">inventory_2</mat-icon>{{ "app.shopifyOrders.details.packageDetailsTitle" | translate }}</span>
          <div class="v35-measure-header" [formGroup]="parentForm" formGroupName="optionForm"><span class="v35-measure-caption">{{ "app.misc.unitOfMeasure" | translate }}*</span>
              <mat-form-field appearance="outline" class="v35-measure-field">
                <mat-select formControlName="UnitOfMeasure" (selectionChange)="changeMeasurementDisplay($event.value)" panelClass="v35-measure-panel">
                  @for (measure of measures; track measure) {
                    <mat-option [value]="measure.code">{{ measure.name | translate }} </mat-option>
                  }
                </mat-select>
              </mat-form-field></div>
        </mat-card-title>
        <!-- Card content -->
        <br />
        <mat-card-content>
          <!-- Packages details-->
          <!-- Cette ligne a été modifié pour rendre le card responsive en mettant les différents mat-form-field dans un div flex | zidane-->
          <!-- <div class="form" formArrayName="packageForm"></div> -->

          <div formArrayName="packageForm">
            @for (package of packages().controls; track package; let packageIndex = $index; let count = $count) {
              <ng-container class="row">
                <div class="row v35-package-row">
                  <ng-container [formGroupName]="packageIndex">
                    <!-- Cette ligne a été enlevé. il contenait les différents champs jusqu'aux boutons pour dupliquer et supprimer -->
                    <!-- <div class="form__row"></div> -->
                    <!-- Custom Packages.  Upon selection we fill the fields automatically -->
                    @if (!isGuest) {
                      <mat-form-field appearance="outline" style="width: 10vw">
                        <mat-label> {{ "app.misc.predefined" | translate }}</mat-label>
                        <mat-select (selectionChange)="customPackagesChanged($event.value, packageIndex)">
                          @for (customPackage of customPackages; track customPackage) {
                            <mat-option [value]="customPackage.PAC_ID"> {{ customPackage.PAC_Name }}</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    }
                    <!-- Package type without documents only, all packages type are available -->
                    <mat-form-field appearance="outline" style="width: 10vw">
                      <mat-label>
                        {{ "app.shopifyOrders.details.packageDetails.packageTypeLabel" | translate }}*
                      </mat-label>
                      <mat-select formControlName="packageType">
                        @for (type of packageTypes; track type) {
                          <mat-option [value]="type.code">{{ type.name | translate }} </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    <!-- Quantity -->
                    <mat-form-field appearance="outline" style="width: 7vw">
                      <mat-label>{{ "app.shopifyOrders.details.packageDetails.quantity" | translate }}</mat-label>
                      <input
                        matInput
                        class="text-right-align"
                        type="text"
                        pattern="[0-9]*"
                        required
                        placeholder="{{ 'app.shopifyOrders.details.packageDetails.quantity' | translate }}"
                        formControlName="quantity"
                      />
                    </mat-form-field>
                    <!-- Depth -->
                    <mat-form-field appearance="outline" style="width: 7vw">
                      <mat-label>{{ "app.shopifyOrders.details.packageDetails.depth" | translate }}</mat-label>
                      @if (metricMeasureDisplayed) {
                        <span matSuffix>&nbsp;cm&nbsp;</span>
                      }
                      @if (!metricMeasureDisplayed) {
                        <span matSuffix>&nbsp;{{ "app.misc.inch" | translate }}&nbsp;</span>
                      }
                      <input
                        matInput
                        class="text-right-align"
                        type="text"
                        pattern="[0-9.]*"
                        required
                        placeholder="{{ 'app.shopifyOrders.details.packageDetails.depth' | translate }}"
                        formControlName="depth"
                      />
                    </mat-form-field>
                    <!-- Width -->
                    <mat-form-field appearance="outline" style="width: 7vw">
                      <mat-label>{{ "app.shopifyOrders.details.packageDetails.width" | translate }}</mat-label>
                      @if (metricMeasureDisplayed) {
                        <span matSuffix>&nbsp;cm&nbsp;</span>
                      }
                      @if (!metricMeasureDisplayed) {
                        <span matSuffix>&nbsp;{{ "app.misc.inch" | translate }}&nbsp;</span>
                      }
                      <input
                        matInput
                        class="text-right-align"
                        type="text"
                        pattern="[0-9.]*"
                        required
                        placeholder="{{ 'app.shopifyOrders.details.packageDetails.width' | translate }}"
                        formControlName="width"
                      />
                    </mat-form-field>
                    <!-- Height -->
                    <mat-form-field appearance="outline" style="width: 7vw">
                      <mat-label>{{ "app.shopifyOrders.details.packageDetails.height" | translate }}</mat-label>
                      @if (metricMeasureDisplayed) {
                        <span matSuffix>&nbsp;cm&nbsp;</span>
                      }
                      @if (!metricMeasureDisplayed) {
                        <span matSuffix>&nbsp;{{ "app.misc.inch" | translate }}&nbsp;</span>
                      }
                      <input
                        matInput
                        class="text-right-align"
                        type="text"
                        pattern="[0-9.]*"
                        required
                        placeholder="{{ 'app.shopifyOrders.details.packageDetails.height' | translate }}"
                        formControlName="height"
                      />
                    </mat-form-field>
                    <!-- Weight -->
                    <mat-form-field appearance="outline" style="width: 7vw">
                      <mat-label>{{ "app.shopifyOrders.details.packageDetails.weight" | translate }}</mat-label>
                      @if (metricMeasureDisplayed) {
                        <span matSuffix>&nbsp; kg&nbsp;</span>
                      }
                      @if (!metricMeasureDisplayed) {
                        <span matSuffix>&nbsp; lb&nbsp;</span>
                      }
                      <input
                        matInput
                        class="text-right-align"
                        type="text"
                        pattern="[0-9.]*"
                        required
                        placeholder="{{ 'app.shopifyOrders.details.packageDetails.weight' | translate }}"
                        formControlName="weight"
                        (change)="validateDryIceWeight(package)"
                      />
                    </mat-form-field>
                    <!-- Dry Ice Weight -->
                    @if (isDryIce && !documentOnlyChecked) {
                      <div>
                        @if (isDryIce && !isQuickQuote) {
                          <mat-form-field appearance="outline" style="width: 7vw">
                            <mat-label>{{
                              "app.shopifyOrders.details.packageDetails.dryIceWeight" | translate
                            }}</mat-label>
                            @if (metricMeasureDisplayed) {
                              <span matSuffix>&nbsp; kg&nbsp;</span>
                            }
                            @if (!metricMeasureDisplayed) {
                              <span matSuffix>&nbsp; lb&nbsp;</span>
                            }
                            <input
                              matInput
                              class="text-right-align"
                              type="text"
                              pattern="[0-9.]*"
                              required
                              placeholder="{{ 'app.shopifyOrders.details.packageDetails.dryIceWeight' | translate }}"
                              formControlName="dryIceWeight"
                              (change)="validateDryIceWeight(package)"
                            />
                          </mat-form-field>
                        }
                      </div>
                    }
                    @if (!isDryIce && !documentOnlyChecked) {
                      <div>
                        @if (isDryIce) {
                          <mat-form-field appearance="outline" style="width: 7vw">
                            <mat-label>{{
                              "app.shopifyOrders.details.packageDetails.dryIceWeight" | translate
                            }}</mat-label>
                            @if (metricMeasureDisplayed) {
                              <span matSuffix>&nbsp; kg&nbsp;</span>
                            }
                            @if (!metricMeasureDisplayed) {
                              <span matSuffix>&nbsp; lb&nbsp;</span>
                            }
                            <input
                              matInput
                              class="text-right-align"
                              type="text"
                              pattern="[0-9.]*"
                              placeholder="{{ 'app.shopifyOrders.details.packageDetails.dryIceWeight' | translate }}"
                              formControlName="dryIceWeight"
                            />
                          </mat-form-field>
                        }
                      </div>
                    }
                    <div class="v35-row-actions" aria-label="Package actions">
                      <button type="button" mat-icon-button class="v35-duplicate-action"
                        [matTooltip]="'app.quotes.duplicate' | translate"
                        (click)="onDuplicatePackage(packageIndex)">
                        <mat-icon>content_copy</mat-icon>
                      </button>
                      <button type="button" mat-icon-button class="v35-delete-action"
                        [matTooltip]="'app.quotes.delete' | translate" [disabled]="count === 1"
                        (click)="onRemovePackage(packageIndex)">
                        <mat-icon>close</mat-icon>
                      </button>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            }
          </div>

          <!-- Add package button -->
          <!-- Ce div a été modifié pour séparer les champs du bouton ADD PACKAGE -->
          <!-- <div class="form__row form__row--end"> -->
          <div class="form__row v35-package-footer" formArrayName="packageForm">
            <button
              mat-raised-button
              style="max-height: 35px; width: 200px"
              color="primary"
              (click)="onAddPackage()"
              type="button"
            >
              {{ "app.shopifyOrders.details.addPackage" | translate }}
              <mat-icon class="material-icons"> add_circle </mat-icon>
            </button>
            <div class="v35-dry-ice-footer" [formGroup]="parentForm" formGroupName="optionForm">@if (!documentOnlyChecked && !isQuickQuote) {
                <mat-checkbox class="v35-switch" formControlName="IsDryIce" (change)="dryIceChanged($event)" #dryIce>
                    {{ "app.shopifyOrders.details.options.isDryIce" | translate }}
                  </mat-checkbox>
              }</div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <!-- Options -->
  <div class="construct-shipment__row" [formGroup]="parentForm">
    <div class="construct-shipment__card">
      <mat-card appearance="outlined">
        <mat-card-title><mat-icon class="v35-heading-icon">tune</mat-icon>{{ "app.shopifyOrders.details.options.optionsTitle" | translate }}</mat-card-title>
        <mat-card-content>
          <div formGroupName="optionForm">
            <div class="form__row v35-options-switches">
              <!-- Signature required -->
              <mat-checkbox class="v35-switch" formControlName="IsSignatureRequired">
                  {{ "app.shopifyOrders.details.options.signatureRequired" | translate }}
                </mat-checkbox>

              <!-- Saturday delivery -->
              @if (!isQuickQuote) {
                <mat-checkbox class="v35-switch" formControlName="IsSaturdayDelivery">
                    {{ "app.shopifyOrders.details.options.isSaturdayDelivery" | translate }}
                  </mat-checkbox>
              }

              <!-- Special Handling -->
              @if (!isQuickQuote) {
                <mat-checkbox class="v35-switch" formControlName="IsSpecialHandling">
                    {{ "app.shopifyOrders.details.options.isSpecialHandling" | translate }}
                  </mat-checkbox>
              }

              <!-- Hold At Location -->
              @if (!isQuickQuote) {
                <mat-checkbox class="v35-switch" formControlName="IsHoldAtLocation">
                    {{ "app.shopifyOrders.details.options.isHoldAtLocation" | translate }}
                  </mat-checkbox>
              }
            </div>

            <!-- Instruction and reference section -->
            @if (!isQuickQuote) {
              <div class="form__row">
                <!-- Instructions -->
                <mat-form-field appearance="outline" style="margin-right: 10px !important">
                  <mat-label>{{ "app.shopifyOrders.details.options.instructions" | translate }}</mat-label>
                  <input
                    matInput
                    type="text"
                    maxlength="90"
                    placeholder="{{ 'app.shopifyOrders.details.options.instructions' | translate }}"
                    formControlName="Instructions"
                  />
                </mat-form-field>
                <!-- Reference -->
                <mat-form-field appearance="outline" style="margin-right: 10px !important">
                  <mat-label>{{ "app.shopifyOrders.details.options.reference" | translate }} (35c)</mat-label>
                  <input
                    matInput
                    maxlength="35"
                    type="text"
                    placeholder="{{ 'app.shopifyOrders.details.options.reference' | translate }}"
                    formControlName="Reference"
                  />
                </mat-form-field>
              </div>
            }

            <!-- Shipment date, currencies, insurance and vehicle -->
            <div class="form__row v35-delivery-row">
              @if (!isQuickQuote) {
                <mat-form-field appearance="outline" class="v35-options-date">
                  <mat-label>{{ "app.shopifyOrders.details.options.shipmentDate" | translate }}</mat-label>
                  <input matInput [readonly]="true" formControlName="ShipmentDate" [matDatepicker]="picker" [min]="minDate" [max]="maxDate" />
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
              }

              <mat-form-field appearance="outline" class="v35-options-currency">
                <mat-label>{{ "app.shopifyOrders.details.dutiable.currency" | translate }}</mat-label>
                <mat-select formControlName="GlobalCurrency" (selectionChange)="globalCurrencyChanged($event.value)">
                  @for (type of currency; track type) {
                    <mat-option [value]="type.code">{{ type.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="v35-options-insurance">
                <mat-label>{{ "app.shopifyOrders.details.options.isInsurance" | translate }}</mat-label>
                <mat-select formControlName="IsInsurance" (selectionChange)="changeInsuranceRequiredStatus($event.value)">
                  @for (type of yesNo; track type) {
                    <mat-option [value]="type.code">{{ type.name | translate }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>

              @if (insuranceRequiredSelected) {
                <mat-form-field appearance="outline" class="v35-options-insurance-currency">
                  <mat-label>{{ "app.shopifyOrders.details.options.insuranceCurrency" | translate }}</mat-label>
                  <mat-select formControlName="InsuranceCurrency" [disabled]="true">
                    @for (type of currency; track type) {
                      <mat-option [value]="type.code">{{ type.name }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" class="v35-options-insurance-value">
                  <mat-label>{{ "app.shopifyOrders.details.options.insuranceValue" | translate }}</mat-label>
                  <input #ins matInput type="text" inputmode="numeric" class="text-right-align" formControlName="InsuranceValue" />
                  <span matPrefix style="margin-left: 4px">$&nbsp;</span>
                </mat-form-field>
              }

              @if (!isQuickQuote) {
                <mat-form-field appearance="outline" class="v35-options-vehicle">
                  <mat-label>{{ "app.misc.vehicle" | translate }}</mat-label>
                  <mat-select formControlName="VehicleTypes">
                    @for (type of vehicleTypes; track type) {
                      <mat-option [value]="type.code">{{ type.name | translate }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <!-- Product Detail Form -->
  @if (!isQuickQuote) {
    <div class="construct-shipment__row" [formGroup]="parentForm">
      @if (productFormVisible && !documentOnlyChecked) {
        <div class="construct-shipment__card">
          <mat-card appearance="outlined">
            <!-- Header -->
            <mat-card-title class="v35-customs-heading"><mat-icon class="v35-heading-icon">account_balance_wallet</mat-icon>
              {{ "app.shopifyOrders.details.productsDetailsTitle" | translate }}
            </mat-card-title>
            <!-- Importer Of Record -->
            <br />
            <input type="checkbox" id="toggle" [checked]="isExpanded" (change)="ExpendImporterOfRecord()" />
            <div class="v35-importer-toolbar"><label for="toggle" class="toggle-button">
              @if (!isExpanded) {
                <span class="toggle-icon">▼</span>
              }
              @if (isExpanded) {
                <span class="toggle-icon">▲</span>
              }
              <span class="toggle-text" [hidden]="isExpanded"
                >{{ "app.misc.importerOfRecord" | translate }} {{ "app.misc.clickToExpand" | translate }}</span
              >
              <span class="toggle-text" [hidden]="!isExpanded"
                >{{ "app.misc.importerOfRecord" | translate }} {{ "app.misc.clickToCollapse" | translate }}</span
              >
            </label>
              @if (!isQuickQuote) {
                <button
                  style="margin-bottom: 12px"
                  type="button"
                  mat-raised-button
                  color="primary"
                  (click)="triggerSuggestions()"
                >
                  <span style="display: flex; align-items: center; gap: 8px">
                    <!-- <img src="assets/images/AILogo.png" width="32" height="32" alt="AI"> -->
                    <mat-icon>memory</mat-icon>
                    {{ "app.misc.aiSuggestions" | translate }}
                  </span>
                </button>
              }</div>
            <div class="expandableContent v35-importer-panel" [class.v35-importer-open]="isExpanded">
              <div class="expandable-content">
                <br />
                <div class="construct-shipment__card" [formGroup]="parentForm">
                  <mat-card appearance="outlined">
                    <!-- <mat-card-title>
                                                                                        {{ "app.shopifyOrders.details.shipper" | translate }}
                                                                                      </mat-card-title> -->
                    <mat-card-content>
                      <div class="form" formGroupName="iorForm">
                        @if (!isQuickQuote) {
                          <mat-form-field appearance="outline">
                            <mat-label>{{
                              "app.shopifyOrders.details.shipperConsigneeDetails.companyName" | translate
                            }}</mat-label>
                            <input
                              matInput
                              maxlength="100"
                              [matAutocomplete]="autoShipperCompanyName"
                              placeholder="{{
                                'app.shopifyOrders.details.shipperConsigneeDetails.companyName' | translate
                              }}"
                              formControlName="companyName"
                              id="companyNameText"
                              (ngModelChange)="onIorValueChanged()"
                            />
                            <mat-autocomplete
                              #autoShipperCompanyName="matAutocomplete"
                              [displayWith]="GetDisplay(true)"
                              (optionSelected)="SelectedAddress(null, $event)"
                            >
                              @for (option of iorAddresses | async; track option) {
                                <mat-option style="line-height: normal" [value]="option.Row">
                                  <div style="font-size: 14px; font-weight: bold">{{ option.AddressTitle }}</div>
                                  <div style="font-size: 12px; color: gray">{{ option.AddressDetail }}</div>
                                </mat-option>
                              }
                            </mat-autocomplete>
                          </mat-form-field>
                        }
                        @if (!isQuickQuote) {
                          <mat-form-field appearance="outline">
                            <mat-label>{{
                              "app.shopifyOrders.details.shipperConsigneeDetails.personName" | translate
                            }}</mat-label>
                            <input
                              matInput
                              autocomplete="shipper"
                              minlength="3"
                              maxlength="100"
                              placeholder="{{
                                'app.shopifyOrders.details.shipperConsigneeDetails.personName' | translate
                              }}"
                              formControlName="personName"
                              (ngModelChange)="onIorValueChanged()"
                            />
                          </mat-form-field>
                        }
                        <mat-form-field appearance="outline">
                          <mat-label>
                            {{ "app.shopifyOrders.details.shipperConsigneeDetails.countryName" | translate }}
                          </mat-label>
                          <mat-select
                            formControlName="countryID"
                            (selectionChange)="changeIorCountryEvent()"
                            (ngModelChange)="onIorValueChanged()"
                            [typeaheadDebounceInterval]="500"
                          >
                            @for (country of countriesList; track country) {
                              <mat-option [value]="country.CON_ID">
                                {{ country.CON_Name }}
                              </mat-option>
                            }
                          </mat-select>
                        </mat-form-field>
                        @if (!isQuickQuote) {
                          <div class="form__row">
                            <mat-form-field appearance="outline">
                              <mat-label>{{
                                "app.shopifyOrders.details.shipperConsigneeDetails.phone" | translate
                              }}</mat-label>
                              <input
                                matInput
                                type="text"
                                mask="{{ phoneMaskIOR }}"
                                autocomplete="shipper"
                                placeholder="{{
                                  'app.shopifyOrders.details.shipperConsigneeDetails.phone' | translate
                                }}"
                                formControlName="phone"
                              />
                            </mat-form-field>
                            <mat-form-field appearance="outline">
                              <mat-label
                                >{{
                                  "app.shopifyOrders.details.shipperConsigneeDetails.phone" | translate
                                }}
                                Ext.</mat-label
                              >
                              <input
                                matInput
                                type="text"
                                autocomplete="shipper"
                                maxlength="50"
                                placeholder="{{
                                  'app.shopifyOrders.details.shipperConsigneeDetails.phone' | translate
                                }} Ext."
                                formControlName="extension"
                              />
                            </mat-form-field>
                          </div>
                        }
                        @if (!isQuickQuote) {
                          <div class="form__row">
                            <mat-form-field appearance="outline">
                              <mat-label>{{
                                "app.shopifyOrders.details.shipperConsigneeDetails.email" | translate
                              }}</mat-label>
                              <input
                                matInput
                                autocomplete="shipper"
                                maxlength="200"
                                placeholder="{{
                                  'app.shopifyOrders.details.shipperConsigneeDetails.email' | translate
                                }}"
                                formControlName="email"
                              />
                            </mat-form-field>
                          </div>
                        }
                        @if (!isQuickQuote) {
                          <mat-form-field class="full-width v35-search-field" [appearance]="appearance">
                            
                            <input
                              ngx-google-places-autocomplete
                              matInput
                              placeholder="{{ 'app.misc.searchAddress' | translate }}"
                              class="form-control v35-address-search"
                              autocomplete="shipperGoogle"
                              (focus)="changeIorCountryEvent(true)"
                              onfocus="this.setAttribute('autocomplete', 'shipperGoogle')"
                              #iorSearchAddress
                            />
                          </mat-form-field>
                        }
                        @if (!isQuickQuote) {
                          <div class="form__row">
                            <mat-form-field appearance="outline">
                              <mat-label>{{
                                "app.shopifyOrders.details.shipperConsigneeDetails.streetName" | translate
                              }}</mat-label>
                              <input
                                matInput
                                autocomplete="shipper"
                                maxlength="100"
                                placeholder="{{
                                  'app.shopifyOrders.details.shipperConsigneeDetails.streetName' | translate
                                }}"
                                formControlName="streetName"
                                (ngModelChange)="onIorValueChanged()"
                              />
                            </mat-form-field>
                            <mat-form-field appearance="outline">
                              <mat-label>{{
                                "app.shopifyOrders.details.shipperConsigneeDetails.unit" | translate
                              }}</mat-label>
                              <input
                                matInput
                                maxlength="100"
                                placeholder="{{ 'app.shopifyOrders.details.shipperConsigneeDetails.unit' | translate }}"
                                autocomplete="shipper"
                                formControlName="unit"
                                #iorUnitElement
                                (ngModelChange)="onIorValueChanged()"
                              />
                            </mat-form-field>
                          </div>
                        }
                        @if (!isQuickQuote) {
                          <mat-form-field appearance="outline">
                            <mat-label>{{
                              "app.shopifyOrders.details.shipperConsigneeDetails.cityName" | translate
                            }}</mat-label>
                            <input
                              matInput
                              autocomplete="shipper"
                              maxlength="100"
                              placeholder="{{
                                'app.shopifyOrders.details.shipperConsigneeDetails.cityName' | translate
                              }}"
                              formControlName="cityName"
                              (ngModelChange)="onIorValueChanged()"
                            />
                          </mat-form-field>
                        }
                        <div class="form__row">
                          <div style="width: 50%">
                            <mat-form-field appearance="outline">
                              <mat-label>{{
                                "app.shopifyOrders.details.shipperConsigneeDetails.zipCode" | translate
                              }}</mat-label>
                              <input
                                matInput
                                autocomplete="shipper"
                                maxlength="50"
                                placeholder="{{
                                  'app.shopifyOrders.details.shipperConsigneeDetails.zipCode' | translate
                                }}"
                                formControlName="zipCode"
                                (ngModelChange)="onIorValueChanged()"
                              />
                            </mat-form-field>
                          </div>
                          @if (!isQuickQuote) {
                            <div style="width: 49%">
                              <mat-form-field appearance="outline">
                                <mat-label>
                                  {{ "app.misc.state" | translate }}
                                </mat-label>
                                <mat-select
                                  matNativeControl
                                  formControlName="stateID"
                                  (ngModelChange)="onIorValueChanged()"
                                >
                                  @for (state of iorFilteredStateProvinces; track state) {
                                    <mat-option [value]="state.PRV_ID">
                                      {{ state.PRV_Name }}
                                    </mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                            </div>
                          }
                        </div>
                        @if (!isQuickQuote) {
                          <mat-form-field appearance="outline">
                            <mat-label>Notes (1000c)</mat-label>
                            <textarea
                              matInput
                              maxlength="1000"
                              autocomplete="shipper"
                              placeholder="{{ 'app.shopifyOrders.details.specialInstruction' | translate }}"
                              formControlName="specialInstruction"
                            >
                            </textarea>
                          </mat-form-field>
                        }
                        @if (!isQuickQuote) {
                          <mat-form-field appearance="outline">
                            <mat-label>{{ "app.misc.taxID" | translate }}</mat-label>
                            <input
                              matInput
                              autocomplete="shipper"
                              minlength="3"
                              maxlength="100"
                              placeholder="{{ 'app.misc.taxID' | translate }}"
                              formControlName="taxID"
                              (ngModelChange)="onIorValueChanged()"
                            />
                          </mat-form-field>
                        }
                      </div>
                      @if (!isQuickQuote) {
                        <button
                          [disabled]="disableIorSaveAddress || !shipper().valid"
                          type="button"
                          mat-raised-button
                          color="primary"
                          (click)="saveCurrentIorAddress()"
                        >
                          {{ "app.addressEditor.saveAddress" | translate }}
                          <mat-icon class="material-icons"> save </mat-icon>
                        </button>
                      }
                    </mat-card-content>
                  </mat-card>
                </div>
              </div>
            </div>
            <br />
            <!-- Content-->
            <mat-card-content>
              <!-- Dutiable options -->
              <div class="v35-customs-layout">
                <div class="v35-customs-left">
                <div class="v35-customs-top" formGroupName="dutiableForm">
                  <!-- Broker -->
                  <mat-form-field appearance="outline" style="width: 15vw; margin-right: 8px">
                    <mat-label>{{ "app.shopifyOrders.details.dutiable.broker" | translate }}</mat-label>
                    <input
                      matInput
                      maxlength="100"
                      placeholder=" {{ 'app.shopifyOrders.details.dutiable.broker' | translate }}"
                      formControlName="Broker"
                    />
                  </mat-form-field>
                  <!-- Taxe Id -->
                  <mat-form-field appearance="outline" style="width: 15vw; margin-right: 8px">
                    <mat-label>{{ "app.shopifyOrders.details.dutiable.taxId" | translate }}</mat-label>
                    <input
                      matInput
                      maxlength="100"
                      placeholder=" {{ 'app.shopifyOrders.details.dutiable.taxId' | translate }}"
                      formControlName="TaxID"
                    />
                  </mat-form-field>
                  <!-- Currency -->
                  <mat-form-field appearance="outline" class="v35-customs-currency-readonly">
                    <mat-label> {{ "app.shopifyOrders.details.dutiable.currency" | translate }}</mat-label>
                    <mat-select
                      placeholder=" {{ 'app.shopifyOrders.details.dutiable.currency' | translate }}"
                      formControlName="Currency"
                    >
                      @for (type of currency; track type) {
                        <mat-option [value]="type.code">
                          {{ type.name }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>

              <!-- Duties and taxes paid by -->
                <mat-form-field appearance="outline" style="width: 10vw; margin-right: 8px">
                  <mat-label> {{ "app.shopifyOrders.details.options.paidByShipper" | translate }}</mat-label>
                  <mat-select
                    placeholder="{{ 'app.shopifyOrders.details.options.paidByShipper' | translate }}"
                    formControlName="DutiesTaxesPaidBy"
                  >
                    @for (type of debitor; track type) {
                      <mat-option [value]="type.code">
                        {{ type.name | translate }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <!-- Invoice Number -->
                <mat-form-field appearance="outline" style="width: 10vw; margin-right: 8px">
                  <mat-label>{{ "app.shopifyOrders.details.dutiable.invoiceNumber" | translate }}</mat-label>
                  <input
                    matInput
                    required
                    maxlength="35"
                    placeholder=" {{ 'app.shopifyOrders.details.dutiable.invoiceNumber' | translate }}"
                    formControlName="InvoiceNumber"
                  />
                </mat-form-field>
                <!-- Invoice Date -->
                <mat-form-field appearance="outline" style="width: 10vw">
                  <mat-label> {{ "app.shopifyOrders.details.dutiable.invoiceDate" | translate }}</mat-label>
                  <input matInput [readonly]="true" formControlName="InvoiceDate" required [matDatepicker]="picker" />
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
                @if (!isQuickQuote) {
                  <mat-form-field appearance="outline" class="v35-recipient-select">
                    <mat-label>{{ "app.pid.receiverVATRegistered" | translate }}</mat-label>
                    <mat-select formControlName="receiverVATRegistered">
                      <mat-option [value]="true">{{ "app.pid.yes" | translate }}</mat-option>
                      <mat-option [value]="false">{{ "app.pid.no" | translate }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                }
              </div>
              <!-- Export Reason -->
              <div formGroupName="dutiableForm" class="form__row v35-customs-export-row">
                <mat-form-field appearance="outline" class="v35-export-reason">
                  <mat-label> {{ "app.shopifyOrders.details.dutiable.exportReason" | translate }}</mat-label>
                  <mat-select
                    style="margin-right: 12px"
                    placeholder=" {{ 'app.shopifyOrders.details.dutiable.exportReason' | translate }}"
                    formControlName="ExportReason"
                  >
                    @for (type of exportReason; track type) {
                      <mat-option [value]="type.code">
                        {{ type.name | translate }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <!-- Export Reason Detail -->
                <mat-form-field appearance="outline" class="v35-export-reason-detail">
                  <mat-label
                    >{{ "app.shopifyOrders.details.dutiable.exportReasonDetail" | translate }} (300c)</mat-label
                  >
                  <textarea
                    class="exportReasonDetailText"
                    matInput
                    rows="1"
                    maxlength="300"
                    autocomplete="exportreasondetail"
                    placeholder="{{ 'app.shopifyOrders.details.dutiable.exportReasonDetail' | translate }} (300c)"
                    formControlName="ExportReasonDetail"
                  >
                  </textarea>
                </mat-form-field>
              </div>
              </div>
              </div>
              <!-- Products list -->
              <div class="form v35-products" formGroupName="productForm">
                <mat-label class="v35-products-heading">{{
                  "app.shopifyOrders.details.productsDetails.productsDetailsListTitle" | translate
                }}</mat-label>
                <br />
                @for (product of products().controls; track product; let productIndex = $index) {
                  <ng-container [formGroupName]="productIndex">
                    <div class="row v35-product-row">
                      <!-- Custom Products.  Upon selection we fill the fields automatically -->
                      <mat-form-field appearance="outline" style="width: 10.5vw">
                        <mat-label> {{ "app.misc.predefined" | translate }}</mat-label>
                        <mat-select (selectionChange)="customProductsChanged($event.value, productIndex)">
                          @for (product of customProducts; track product) {
                            <mat-option [value]="product.Pro_Id">
                              {{ product.Pro_Name }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                      <!-- Description -->
                      <mat-form-field appearance="outline" style="width: 10.5vw">
                        <mat-label>{{ "app.shopifyOrders.details.productsDetails.description" | translate }}</mat-label>
                        <input
                          matInput
                          required
                          autocomplete="products"
                          maxlength="50"
                          placeholder=" {{ 'app.shopifyOrders.details.productsDetails.description' | translate }}"
                          formControlName="description"
                        />
                      </mat-form-field>
                      <!-- Country input line with selector-->
                      <!-- Task #4488 point #4 -->
                      <mat-form-field appearance="outline" style="width: 10.5vw">
                        <mat-label>
                          {{ "app.shopifyOrders.details.productsDetails.countryOfOrigin" | translate }}
                        </mat-label>
                        <mat-select required formControlName="countryOfOrigin">
                          @for (country of countriesList; track country) {
                            <mat-option [value]="country.CON_Code">
                              {{ country.CON_Name }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                      <!-- Country Origin -->
                      <!-- <mat-form-field appearance="outline">
                                                                                                                            <mat-label>{{'app.shopifyOrders.details.productsDetails.countryOfOrigin' | translate}}</mat-label>
                                                                                                                            <input matInput maxlength="100" class="text-right-align" required autocomplete="products"
                                                                                                                              placeholder="{{'app.shopifyOrders.details.productsDetails.countryOfOrigin' | translate}}"
                                                                                                                              formControlName="countryOfOrigin" />
                                                                                                                            </mat-form-field> -->
                      <!-- HS code-->
                      <mat-form-field appearance="outline" style="width: 10.5vw">
                        <mat-label>{{ "app.shopifyOrders.details.productsDetails.hsCode" | translate }}</mat-label>
                        <input
                          matInput
                          maxlength="100"
                          class="text-right-align"
                          autocomplete="products"
                          placeholder="{{ 'app.shopifyOrders.details.productsDetails.hsCode' | translate }}"
                          formControlName="hsCode"
                        />
                      </mat-form-field>
                      <!-- Quantity -->
                      <mat-form-field appearance="outline" style="width: 10.5vw">
                        <mat-label>{{ "app.shopifyOrders.details.productsDetails.qty" | translate }}</mat-label>
                        <input
                          matInput
                          class="text-right-align"
                          type="text"
                          pattern="[0-9]*"
                          required
                          autocomplete="products"
                          placeholder="{{ 'app.shopifyOrders.details.productsDetails.qty' | translate }}"
                          formControlName="qty"
                        />
                      </mat-form-field>
                      <!-- Unit Weight -->
                      <mat-form-field appearance="outline" style="width: 7vw">
                        <mat-label>{{ "app.shopifyOrders.details.packageDetails.weight" | translate }}</mat-label>
                        @if (metricMeasureDisplayed) {
                          <span matSuffix>&nbsp; kg&nbsp;</span>
                        }
                        @if (!metricMeasureDisplayed) {
                          <span matSuffix>&nbsp; lb&nbsp;</span>
                        }
                        <input
                          matInput
                          class="text-right-align"
                          type="text"
                          pattern="[0-9.]*"
                          required
                          autocomplete="products"
                          placeholder="{{ 'app.shopifyOrders.details.packageDetails.weight' | translate }}"
                          formControlName="weight"
                        />
                      </mat-form-field>
                      <!-- Unit Price -->
                      <mat-form-field appearance="outline" style="width: 10.5vw">
                        <mat-label>{{ "app.shopifyOrders.details.productsDetails.unitPrice" | translate }}</mat-label>
                        <span matSuffix> &nbsp;$&nbsp; </span>
                        <input
                          matInput
                          class="text-right-align"
                          type="text"
                          pattern="[0-9.]*"
                          required
                          autocomplete="products"
                          placeholder="{{ 'app.shopifyOrders.details.productsDetails.unitPrice' | translate }}"
                          formControlName="unitPrice"
                        />
                      </mat-form-field>
                      <!-- Button to remove a product -->
                      <div class="v35-product-action">
                        <button type="button" mat-icon-button class="v35-delete-action"
                          [matTooltip]="'app.quotes.delete' | translate"
                          (click)="onRemoveProduct(productIndex)">
                          <mat-icon>close</mat-icon>
                        </button>
                      </div>
                    </div>
                  </ng-container>
                }
                <!-- Buttons GET ALL PRODUCTS ON ORDERS and ADD NEW PRODUCT -->
                <div class="form__row">
                  <!-- <button mat-raised-button *ngIf="order.Dutiable.ShipmentDutiableRows.length > 0" color="primary" type="button"
                                                                                                                                (click)="onGetExistingProducts()" type="button">
                                                                                                                                {{'app.shopifyOrders.details.getAllOrderProducts' | translate}}
                                                                                                                              </button> -->
                  <div>
                    <button mat-raised-button color="primary" (click)="onAddProduct()" type="button">
                      {{ "app.shopifyOrders.details.addNewProduct" | translate }}
                      <mat-icon class="material-icons"> add_circle </mat-icon>
                    </button>
                  </div>
                </div>
              </div>
              <hr style="margin-top: 20px" />
              <!----------------------------------------------------------------------------------------------------->
              <!-- If Paperless is NO, there's no reason to ask the Invoice Type: 2023-5-19 (Patrick)              -->
              <!-- if the customer requests to be personalized for the Invoice Type, CSAPI doesn't need to know it -->
              <!----------------------------------------------------------------------------------------------------->
              <!-- Task #4551: PaperLess and InvoiceType options -->
              @if (isPaperlessAvailable) {
                <div formGroupName="dutiableForm" style="margin-top: 20px" class="form__row v35-paperless-row">
                  <!-- Paperless -->
                  <mat-form-field appearance="outline" style="width: 12vw; margin-right: 8px">
                    <mat-label> {{ "app.shopifyOrders.details.dutiable.paperLess" | translate }}</mat-label>
                    <mat-select
                      placeholder="{{ 'app.shopifyOrders.details.dutiable.paperLess' | translate }}"
                      formControlName="PaperLess"
                      (selectionChange)="changePaperLessOption($event.value)"
                    >
                      @for (type of yesNo; track type) {
                        <mat-option [value]="type.code">
                          {{ type.name | translate }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <!-- Invoice Type-->
                  @if (isPaperLess === true) {
                    <div>
                      <mat-form-field appearance="outline" style="width: 10vw; align-content: end">
                        <mat-label> {{ "app.shopifyOrders.details.dutiable.invoiceType" | translate }}*</mat-label>
                        <mat-select formControlName="InvoiceType" (selectionChange)="changeInvoiceType($event.value)">
                          @for (invoiceType of invoiceTypes; track invoiceType) {
                            <mat-option [value]="invoiceType.code">{{ invoiceType.name | translate }} </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                  }
                  @if (isPaperLess === true && isInvoiceTypeSystem === true) {
                    <mat-form-field appearance="outline" style="width: 30vw; margin-left: 8px">
                      <mat-label>{{ 'app.shipmentSummary.invoiceTitle' | translate }}</mat-label>
                      <mat-select formControlName="InvoiceTitle" panelClass="invoice-title-panel">
                        <mat-option value="PROFORMA">{{ 'app.shipmentSummary.proformaInvoice' | translate }}</mat-option>
                        <mat-option value="COMMERCIAL">{{ 'app.shipmentSummary.commercialInvoice' | translate }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <button mat-raised-button color="primary" type="button" class="v35-preview-invoice-button" (click)="showProforma()">
                      {{ "app.shopifyOrders.details.previewInvoice" | translate }}
                      <mat-icon class="material-icons">visibility</mat-icon>
                    </button>
                  }
                </div>
              }
              <!-- Task #4551: documents upload  -->
              @if (isPaperLess === true) {
                <div class="form" formGroupName="documentForm">
                  @for (document of documents().controls; track document; let documentIndex = $index) {
                    <ng-container [formGroupName]="documentIndex">
                      <div class="documentRow v35-paperless-upload">
                        <!-- Document Type -->
                        <div
                          [style.pointer-events]="DisableDocumentType(documentIndex) ? 'none' : 'auto'"
                          [style.opacity]="DisableDocumentType(documentIndex) ? 0.5 : 1"
                        >
                          <mat-form-field appearance="outline" style="width: 10vw; align-content: end">
                            <mat-label> {{ "app.shopifyOrders.details.dutiable.documentType" | translate }}*</mat-label>
                            <mat-select
                              formControlName="documentType"
                              (selectionChange)="changeDocumentType($event.value, documentIndex)"
                            >
                              @for (documentType of documentTypes; track documentType) {
                                <mat-option [value]="documentType.code"
                                  >{{ documentType.name | translate }}
                                </mat-option>
                              }
                            </mat-select>
                          </mat-form-field>
                        </div>
                        <!-- FileName -->
                        <mat-form-field appearance="outline" style="width: 20vw">
                          <mat-label>{{ "app.shopifyOrders.details.dutiable.documentFileName" | translate }}</mat-label>
                          <input
                            matInput
                            [required]="isFileNameRequired(documentIndex)"
                            maxlength="500"
                            [readonly]="true"
                            placeholder=" {{ 'app.shopifyOrders.details.dutiable.documentFileName' | translate }}"
                            formControlName="fileName"
                          />
                        </mat-form-field>
                        <!-- Button to upload -->
                        <div class="documentButton">
                          <input type="file" class="file-input" (change)="onFileSelected($event)" #fileUpload />
                          <button
                            mat-raised-button
                            color="primary"
                            type="button"
                            (click)="onUploadDocument(documentIndex)"
                          >
                            {{ "app.shopifyOrders.details.dutiable.uploadDocument" | translate }}
                            <mat-icon class="material-icons"> file_upload </mat-icon>
                          </button>
                        </div>
                        <!-- Button to see the document -->
                        <div class="documentButton">
                          <button
                            mat-raised-button
                            color="primary"
                            type="button"
                            (click)="onViewDocument(documentIndex)"
                            [disabled]="onDocumentNotUploaded(documentIndex) == true"
                          >
                            {{ "app.shopifyOrders.details.dutiable.viewDocument" | translate }}
                            <mat-icon class="material-icons"> visibility </mat-icon>
                          </button>
                        </div>
                        <!-- Button to delete a document -->
                        <div class="documentButton">
                          <button
                            mat-raised-button
                            type="button"
                            color="warn"
                            (click)="onDeleteDocument(documentIndex)"
                          >
                            {{ "app.shopifyOrders.details.dutiable.deleteDocument" | translate }}
                            <mat-icon class="material-icons"> delete </mat-icon>
                          </button>
                        </div>
                        <!-- Button to add a new document -->
                        <!-- The ngIf is to have the button only on the last row -->
                        <!-- The style.visibility is to hide the button if there are 5 rows -->
                        @if (documentIndex == documents().length - 1) {
                          <div class="documentButton">
                            <button
                              [style.visibility]="IsAddUnAvailable(documentIndex) ? 'hidden' : 'visible'"
                              mat-raised-button
                              color="primary"
                              type="button"
                              (click)="onAddDocument(documentIndex)"
                            >
                              {{ "app.shopifyOrders.details.dutiable.addDocument" | translate }}
                              <mat-icon class="material-icons"> add_circle </mat-icon>
                            </button>
                          </div>
                        }
                      </div>
                    </ng-container>
                  }
                </div>
              }
            </mat-card-content>
          </mat-card>
        </div>
      }
    </div>
  }
</div>

<app-volume-calculator></app-volume-calculator>

<app-customs-suggestion
  [orderData]="parentForm.value"
  [isFrench]="isFrench"
  [exportReasonEnum]="exportReason"
  [currencyEnum]="currency"
  (customsSuggestions)="handleSuggestions($event)"
  #customsComp
>
</app-customs-suggestion>

<!-- Overlay displayed while the page is processing something -->
@if (isProcessing) {
  <app-processing-overlay [message]="'app.misc.processing' | translate"> </app-processing-overlay>
}
